module.exports = __webpack_public_path__ + "static/media/chatLoader.5483f95c.gif";